import { Divider, IconButton } from '@mui/material';
import type { Currency } from '@weft/types';
import React from 'react';
import { Price } from '../../../../../../components/design/Price';
import { CloseIcon } from '../../../../../../components/icons';

type LivePreviewContainerProps = React.PropsWithChildren<{
  title: React.ReactNode;
  currency: Currency;
  itemsCount: number;
  totalAmount: number;
  onHide?: () => void;
}>;

export const LivePreviewContainer: React.FC<LivePreviewContainerProps> = ({ children, title, currency, itemsCount, totalAmount, onHide }) => {
  return (
    <div className="relative h-full w-full min-w-[354px] max-w-[354px] border-l border-l-[#DFEBF1] bg-white px-6 py-4">
      <div className="flex items-center justify-between text-center">
        <span className="text-sm font-normal leading-4">{title}</span>
        <IconButton onClick={onHide}>
          <CloseIcon
            color="#576063"
          />
        </IconButton>
      </div>

      <div className="mt-4 flex justify-between">
        <div className="flex gap-x-1">
          <span className="text-[10px] font-light text-[#606A6E]">Currency: </span>
          <span className="text-[10px] font-normal text-[#10191C]">{currency}</span>
        </div>

        <Divider
          className="mx-3"
          orientation="vertical"
          flexItem
        />

        <div className="flex gap-x-1">
          <span className="text-[10px] font-light text-[#606A6E]">Items:</span>
          <span className="text-[10px] font-normal text-[#10191C]">{itemsCount}</span>
        </div>

        <Divider
          className="mx-3"
          orientation="vertical"
          flexItem
        />

        <div className="flex flex-1 gap-x-1">
          <span className="text-[10px] font-light text-[#606A6E]">Sub Total:</span>
          <Price
            currency={currency}
            className="text-[10px] font-normal text-[#10191C]"
            align="left"
          >
            {totalAmount}
          </Price>
        </div>
      </div>

      <Divider className="my-2"/>

      <div className="absolute right-0 flex h-full w-full flex-1 flex-col overflow-y-auto px-6 pb-[90px]">
        {children}
      </div>
    </div>
  );
};